import ICompany from "./ICompany";

export default interface ISession {
  qrCode?: string;
  isTablet?: boolean;
  tableNumber?: number;
  commandNumber?: number;
  companyId?: number;
  company?: ICompany;
}

export enum SessionMode {
  ReadOnly = "READONLY",
  Table = "TABLE",
  Tablet = "TABLET",
}
